module.exports = __webpack_public_path__ + "static/media/face3b.efd5b43a.jpg";